module.exports = __webpack_public_path__ + "static/img/class_task_student.6030a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class_task_student.png
// module id = UwDf
// module chunks = 2